import 'react-datepicker/dist/react-datepicker.css'
import TextInput from '@/components/DEPRECATED_UI/TextInput'
import { InputGroup } from '@/components/Style/Common'
import type { Address } from '@/types/AddIncome'

import type { PropertyDispatch } from './Behaviour/PropertyDispatch'
import { Property } from './Behaviour/PropertyDispatch'

interface Props {
  address: Address
  propertyDispatch: PropertyDispatch
}

const AddressInput: React.FC<Props> = ({ address, propertyDispatch }) => {
  return (
    <div>
      <TextInput
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          propertyDispatch.set(Property.CompanyAddressLine1, e.target.value)
        }
        value={address.line1}
        label="Line 1"
      />
      <TextInput
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          propertyDispatch.set(Property.CompanyAddressLine2, e.target.value)
        }
        value={address.line2}
        label="Line 2"
      />
      <InputGroup>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            propertyDispatch.set(Property.CompanyAddressCity, e.target.value)
          }
          value={address.city}
          label="City"
        />
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            propertyDispatch.set(Property.CompanyAddressCounty, e.target.value)
          }
          value={address.county}
          label="County"
        />
      </InputGroup>
      <InputGroup>
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            propertyDispatch.set(Property.CompanyAddressPostCode, e.target.value)
          }
          value={address.postcode}
          label="Post Code"
        />
        <TextInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            propertyDispatch.set(Property.CompanyAddressCountry, e.target.value)
          }
          value={address.country}
          label="Country"
        />
      </InputGroup>
    </div>
  )
}

export default AddressInput
